import { useEffect, useRef, RefObject } from "react";

export function useClickAway<E extends HTMLElement>(
  callback: (event: MouseEvent | TouchEvent) => void
): RefObject<E | null> {
  const ref = useRef<E | null>(null);

  // We should keep the callback updated to always use the latest passed function
  useEffect(() => {
    refCallback.current = callback;
  }, [callback]);

  const refCallback = useRef(callback);

  useEffect(() => {
    const handler = (event: MouseEvent | TouchEvent) => {
      const element = ref.current;
      if (element && !element.contains(event.target as Node)) {
        refCallback.current(event);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, []);

  return ref;
}
